require('/ui/components/filters/filterpill.module.scss.module.css');

export const pillContainer = "_pill-container_1irji_1";
export const smallViewportSupport = "_small-viewport-support_1irji_1";
export const pillBase = "_pill-base_1irji_1";
export const pill = "_pill_1irji_1 _pill-base_1irji_1";
export const defaultPill = "_default-pill_1irji_1 _pill-base_1irji_1";
export const textWrapPill = "_text-wrap-pill_1irji_1";
export const pillButton = "_pill-button_1irji_1";
export const labelButton = "_label-button_1irji_1 _pill-button_1irji_1";
export const deletableLabelButton = "_deletable-label-button_1irji_1 _pill-button_1irji_1";
export const deleteButton = "_delete-button_1irji_1 _pill-button_1irji_1";
export const searchPill = "_search-pill_1irji_1 _pill-base_1irji_1";
export const emptyOrOpenSearchPill = "_empty-or-open-search-pill_1irji_1 _pill-base_1irji_1";
export const searchIcon = "_search-icon_1irji_1";
export const searchInputWrapper = "_search-input-wrapper_1irji_1";
export const searchInput = "_search-input_1irji_1";
export const footer = "_footer_1irji_1";
